import React from "react";
import {connect} from "react-redux";
import {EffacerPicto} from "../Picto/EffacerPicto";
import FermerRecherchePicto from "../Picto/FermerRecherchePicto";


class ClearBarreRecherche extends React.Component{

    constructor() {
        super();
    }

    render() {
        return (<FermerRecherchePicto isHeader={true }  onPress={this.props.press} style={this.props.style} />);
    }

}


const mapStateToProps = (state) => {
    /*,icon:state.icon*/
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(ClearBarreRecherche);
